import type { Palette } from '@/store/palettes'

export const HIGH_CONTRAST_STORAGE_KEY = 'fitutogether-high-contrast'

function parseHex(hex: string): [number, number, number] {
  const h = hex.replace('#', '')
  return [
    parseInt(h.slice(0, 2), 16),
    parseInt(h.slice(2, 4), 16),
    parseInt(h.slice(4, 6), 16),
  ]
}

function toHex([r, g, b]: [number, number, number]): string {
  return `#${[r, g, b].map((c) => c.toString(16).padStart(2, '0')).join('')}`
}

function mixHex(a: string, b: string, weightA: number): string {
  const [ar, ag, ab] = parseHex(a)
  const [br, bg, bb] = parseHex(b)
  const wB = 1 - weightA
  return toHex([
    Math.round(ar * weightA + br * wB),
    Math.round(ag * weightA + bg * wB),
    Math.round(ab * weightA + bb * wB),
  ])
}

/** Boost palette tokens for stronger text, borders, and background separation. */
export function enhancePaletteForHighContrast(p: Palette): Palette {
  return {
    ...p,
    text: '#0d0d0d',
    ring: mixHex(p.ring, '#1a1a1a', 0.35),
    bg: mixHex(p.bg, '#ffffff', 0.28),
    swatch: mixHex(p.swatch, '#ffffff', 0.12),
  }
}

export function readHighContrastPreference(): boolean {
  try {
    return localStorage.getItem(HIGH_CONTRAST_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export function applyHighContrastDocumentFlag(enabled: boolean): void {
  document.documentElement.dataset.highContrast = enabled ? 'true' : 'false'
}
